import _ from 'lodash';
import fileDownload from 'js-file-download';
import axios from 'axios';

class Helpers {
  static getMonths() {
    return [
      { title: 'Gennaio', value: '01-01' },
      { title: 'Febbraio', value: '01-02' },
      { title: 'Marzo', value: '01-03' },
      { title: 'Aprile', value: '01-04' },
      { title: 'Maggio', value: '01-05' },
      { title: 'Giugno', value: '01-06' },
      { title: 'Luglio', value: '01-07' },
      { title: 'Agosto', value: '01-08' },
      { title: 'Settembre', value: '01-09' },
      { title: 'Ottobre', value: '01-010' },
      { title: 'Novembre', value: '01-11' },
      { title: 'Dicembre', value: '01-12' },
    ];
  }

  static getYears(back, year) {
    // const year = new Date().getFullYear();
    return Array.from({ length: back }, (v, i) => year - back + i + 1);
  }

  static downloadFileFromUri(uri, name) {
    axios({
      url: uri, //your url
      method: 'GET',
      responseType: 'blob', // important
      headers: {
        'Lombardy': 'true',
      },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', name); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  }

  static isEmptyObject(obj) {
    return Object.values(obj).every((value) => {
      return value === '';
    });
  }

  static downloadImageFromUrl(e) {
    e.stopPropagation();
    e.preventDefault();
    fetch(e.target.href, {
      method: 'GET',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Lombardy': 'true',
      },
      mode: 'no-cors',
    })
      .then((res) => {
        return res.blob();
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'image.png'); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      // .then((response) => {
      //   response.arrayBuffer().then(function (buffer) {
      //     const url = window.URL.createObjectURL(new Blob([buffer]));
      //     const link = document.createElement('a');
      //     link.href = url;
      //     link.setAttribute('download', 'image.png'); //or any other extension
      //     document.body.appendChild(link);
      //     link.click();
      //   });
      // })
      .catch((err) => {
        console.log(err);
      });
  }

  static downloadFile(response, name) {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name); //or any other extension
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Download complete remove element
    window.URL.revokeObjectURL(url); // Release blob object
  }

  static getErrorsFromResponse(e) {
    const errorData = e?.response?.data || {};
    return Object.values(errorData).reduce((sum, i) => {
      return [...sum, ...i];
    }, []);
  }

  static getFilePath = (filePath) => {
    return `${window.origin}${filePath}`;
  };

  static hideTicksByCount = (data, tick) => {
    const ratio = data.length / 12;
    if (ratio <= 1) {
      return tick;
    }
    const findIndex = _.findIndex(data, function (o) {
      return o === tick;
    });

    if (findIndex % Math.round(ratio) === 0) {
      return tick;
    }
    return false;
  };

  static numberWithCommas(num, prefix = '') {
    if (0 == num) {
      return '0,0' + prefix;
    }
    if (!num) return '';

    const newNum = num.toString().replace('.', ',');

    return newNum?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + prefix;
  }

  static changeDotToComa(num, prefix) {
    return num?.toString().replaceAll('.', ',') + prefix;
  }

  static getMaxValueFromArrayOfObject(data, param) {
    if (_.maxBy(data, param)) {
      return _.maxBy(data, param)[param];
    }
    return 0;
  }

  static axiosDownload(url, filename) {
    axios
      .get(url, {
        responseType: 'blob',
      })
      .then((res) => {
        fileDownload(res.data, filename);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  static deleteAllHtmlTags(str = '') {
    return str.replace(/<[^>]*>?/gm, '');
  }

  static sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}

export default Helpers;
